"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var CircularProgress_style_1 = __importDefault(require("./CircularProgress.style"));
/**
 * CircularProgress atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-circularprogress--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/CircularProgress Source}
 */
var CircularProgress = function (_a) {
    var className = _a.className, size = _a.size, color = _a.color;
    var classes = (0, CircularProgress_style_1.default)();
    var styleOverrides = {
        color: color || theme_1.default.textColors.primary,
    };
    return ((0, jsx_runtime_1.jsx)(core_1.CircularProgress, { size: size, style: styleOverrides, classes: { circle: classes.circle }, className: className, thickness: 5, role: 'progressbar' }));
};
exports.CircularProgress = CircularProgress;
